module.exports = __webpack_public_path__ + "img/8.955691a2.png";